/*
 |------------------------------------------------------------------------------
 | Event handler utility
 |------------------------------------------------------------------------------
 */

/* ========================================================================== *\
	Imports
/* ========================================================================== */
import '../1-polyfills/CustomEvent';

import { isString, isFunction } from 'lodash';


/* ========================================================================== *\
	Constants
/* ========================================================================== */

const blankElement = document.createElement('div');

/* ========================================================================== *\
	Publish & subscribe
/* ========================================================================== */

/**
 * Dispatch an event
 *
 * Gives the ability to dispatch an event with a dataset,
 * so mechanisms listening to it can behave more specifically.
 *
 * @param {String} [eventName]
 * @param {*} [detail]
 */
function publish(eventName, detail) {
    if (!isString(eventName)) {
        return;
    }

    blankElement.dispatchEvent(new CustomEvent(eventName, { detail }));
}

/**
 * Subscribe to an event.
 *
 * Will provide the dataset to the callback function,
 * so we can store our logic to respond to the event at that point.
 *
 * @param {String} [eventName]
 * @param {Function} [callback]
 */
function subscribe(eventName, callback) {
    if (!isString(eventName) || !isFunction(callback)) {
        return;
    }

    blankElement.addEventListener(eventName, callback);
}

/**
 * Unsubscribe to an event.
 *
 * @param {String} [eventName]
 * @param {Function} [callback]
 */
function unsubscribe(eventName, callback) {
    if (!isString(eventName) || !isFunction(callback)) {
        return;
    }

    blankElement.removeEventListener(eventName, callback);
}

/* ========================================================================== *\
	Exports
/* ========================================================================== */

export { publish, subscribe, unsubscribe };
